module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsWomen.427c432.webp";